<template>
  <div class="pdf-preview-container">
    <div class="pdf-box" v-if="pdfUrl">
      <!-- 触摸缩放事件绑定 -->
      <div 
        class="pdf-canvas-wrap" 
        ref="pdfCanvasWrap" 
        v-if="!isLoadError"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
        @touchcancel="handleTouchEnd"
      ></div>
      <div class="pdf-loading" v-if="isLoading && !isLoadError">加载中...</div>
      <div class="pdf-error-tip" v-if="isLoadError">暂不支持预览该PDF，请检查文件是否有效</div>
    </div>
    <div class="pdf-placeholder" v-else>暂无PDF文件</div>
  </div>
</template>

<script>
export default {
  name: 'PdfPreview',
  // Vue2 标准props定义，支持类型校验和默认值
  props: {
    pdfUrl: {
      type: String,
      default: ''
    },
    scale: {
      type: Number,
      default: 1.2 // 初始缩放比例
    }
  },
  // Vue2 标准data函数，必须返回对象
  data() {
    return {
      newPdfUrl:'',
      isLoading: false,
      isLoadError: false,
      pdfDoc: null,
      pageNum: 1,
      pageRendering: false,
      pageNumPending: null,
      pdfjsLib: null,
      // 缩放相关状态
      currentScale: 1.2,
      touchInfo: {
        isPinching: false,
        startDistance: 0,
        startScale: 0
      },
      renderDebounceTimer: null,
      dpr: window.devicePixelRatio || 1 // 设备像素比（解决高清模糊核心）
    };
  },
  // Vue2 标准watch，immediate+handler写法兼容所有Vue2版本
  watch: {
    pdfUrl: {
      immediate: true,
      handler(newUrl) {
        // console.log('pdfUrl111111111111111', newUrl);
        this.newPdfUrl = this.processPdfUrl(newUrl);
        newUrl ? this.loadPDF() : this.resetPDF();
      }
    },
    scale: {
      immediate: true,
      handler(newVal) {
        this.currentScale = newVal;
      }
    }
  },
  created(){
 
  },
  // Vue2 生命周期，mounted/ beforeDestroy 标准写法
  mounted() {
      console.log('=== PdfPreview 组件挂载 ===');
  console.log('pdfUrl prop:', this.pdfUrl);
  console.log('window.pdfjsLib:', window.pdfjsLib);
  console.log('设备像素比:', window.devicePixelRatio);
    this.initPdfjs();
    // 监听窗口大小变化（适配屏幕旋转）
    window.addEventListener('resize', this.handleWindowResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleWindowResize);
    clearTimeout(this.renderDebounceTimer);
  },
  methods: {
      // 判断 URL 是否有协议，没有则添加 xcyth 前缀
  processPdfUrl(url) {
    if (!url) return url;
    
    // 判断是否包含 http:// 或 https://
    const hasProtocol = /^https?:\/\//i.test(url);
    
    if (hasProtocol) {
      // 已有协议，直接返回
      return url;
    } else {
      // 没有协议，添加 xcyth 前缀
      // 确保 url 以 / 开头
      console.log('pdfUrl333333333333333', url);
     
      const cleanUrl = url.startsWith('/') ? url : '/' + url;
      console.log('pdfUrl444444444444444', cleanUrl);
      return '/profile'+ cleanUrl;
    }
  },
    // 窗口缩放防抖处理
    handleWindowResize() {
      clearTimeout(this.renderDebounceTimer);
      this.renderDebounceTimer = setTimeout(() => {
        if (this.pdfDoc) {
          this.resetCanvasWrap();
          this.renderAllPages();
        }
      }, 300);
    },
    // 初始化 pdfjs（CDN 动态加载，Vue2 环境兼容）
  initPdfjs() {
    console.log('=== 开始初始化 PDF.js ===');
    console.log('当前 window.pdfjsLib:', window.pdfjsLib);
    
    // 检查是否已正确加载
    if (window.pdfjsLib && typeof window.pdfjsLib.GlobalWorkerOptions !== 'undefined') {
      console.log('✓ PDF.js 已加载，直接使用');
      this.pdfjsLib = window.pdfjsLib;
      if (this.newPdfUrl) this.loadPDF();
      return;
    }

    const workerUrl = '/static/js/pdfjs/pdf.worker.min.js';
    const coreUrl = '/static/js/pdfjs/pdf.min.js';

    console.log('Worker URL:', workerUrl);
    console.log('Core URL:', coreUrl);

    this.isLoading = true;
    this.isLoadError = false;

    // 使用 Promise链式加载，确保顺序
    this.loadScriptWithCallback(workerUrl)
      .then(() => {
        console.log('✓ Worker 脚本加载完成');
        // 等待一小段时间确保 worker 完全初始化
        return new Promise(resolve => setTimeout(resolve, 300));
      })
      .then(() => {
        console.log('开始加载 Core 脚本...');
        return this.loadScriptWithCallback(coreUrl);
      })
      .then(() => {
        console.log('✓ Core 脚本加载完成');
        console.log('加载后 window.pdfjsLib:', window.pdfjsLib);
        
        // 强制等待 PDF.js 完全初始化
        return new Promise((resolve, reject) => {
          let attempts = 0;
          const maxAttempts = 10;
          
          const checkPdfjs = () => {
            attempts++;
            console.log(`检查 PDF.js 挂载状态 (${attempts}/${maxAttempts})...`);
            
            if (window.pdfjsLib) {
              if (typeof window.pdfjsLib.GlobalWorkerOptions !== 'undefined') {
                console.log('✓ PDF.js 完全初始化完成');
                resolve();
                return;
              } else {
                console.log('⚠ PDF.js 已加载但 GlobalWorkerOptions 未定义，继续等待...');
              }
            } else {
              console.log('⚠ window.pdfjsLib 仍未定义，继续等待...');
            }
            
            if (attempts < maxAttempts) {
              setTimeout(checkPdfjs, 200);
            } else {
              reject(new Error('PDF.js 初始化超时，可能是脚本加载失败或版本不兼容'));
            }
          };
          
          checkPdfjs();
        });
      })
      .then(() => {
        // 现在可以安全地访问 GlobalWorkerOptions
        this.pdfjsLib = window.pdfjsLib;
        this.pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;
        
        console.log('✓ PDF.js 配置完成');
        console.log('PDF.js 版本:', this.pdfjsLib.version);
        
        this.isLoading = false;
        
        if (this.newPdfUrl) {
          console.log('开始加载 PDF 文件:', this.newPdfUrl);
          this.loadPDF();
        }
      })
      .catch(err => {
        console.error('✗ PDF.js 初始化失败:', err);
        console.error('错误堆栈:', err.stack);
        this.isLoading = false;
        this.isLoadError = true;
        
        // 显示友好错误提示
        const errorMsg = this.getErrorMessage(err);
        console.error('用户提示:', errorMsg);
        
        if (this.$toast) {
          this.$toast.fail(errorMsg);
        } else {
          alert(errorMsg);
        }
      });
  },
  
  // 获取友好的错误提示信息
  getErrorMessage(err) {
    const msg = err.message.toLowerCase();
    if (msg.includes('超时')) {
      return 'PDF 组件加载超时，请检查网络连接后重试';
    } else if (msg.includes('404') || msg.includes('not found')) {
      return 'PDF 组件文件不存在，请联系管理员';
    } else if (msg.includes('版本')) {
      return 'PDF 组件版本不兼容，请刷新页面重试';
    } else {
      return 'PDF 组件加载失败，请刷新页面重试';
    }
  },
  
  // 加载脚本并等待执行完成
  loadScriptWithCallback(url, timeout = 20000) {
    return new Promise((resolve, reject) => {
      console.log('开始加载脚本:', url);
      
      // 检查是否已存在
      const existingScript = document.querySelector(`script[src="${url}"]`);
      if (existingScript) {
        console.log('脚本已存在，跳过加载:', url);
        // 等待现有脚本执行
        setTimeout(resolve, 100);
        return;
      }
      
      const script = document.createElement('script');
      script.src = url;
      script.async = false; // 同步加载，确保顺序
      script.crossOrigin = 'anonymous';
      
      let timer = null;
      let isResolved = false;
      
      const cleanup = () => {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
        if (script) {
          script.onload = null;
          script.onerror = null;
        }
      };
      
      // 超时处理
      timer = setTimeout(() => {
        if (!isResolved) {
          cleanup();
          console.error('脚本加载超时:', url);
          reject(new Error(`加载超时：${url}`));
        }
      }, timeout);
      
      // 加载成功回调
      script.onload = () => {
        if (!isResolved) {
          isResolved = true;
          cleanup();
          console.log('✓ 脚本加载成功:', url);
          resolve();
        }
      };
      
      // 加载失败回调
      script.onerror = () => {
        if (!isResolved) {
          isResolved = true;
          cleanup();
          const errorMsg = `无法加载 PDF 组件：${url}`;
          console.error(errorMsg);
          reject(new Error(errorMsg));
        }
      };
      
      document.head.appendChild(script);
      console.log('脚本已添加到页面:', url);
    });
  },
    // // 初始化pdfjs（CDN动态加载，Vue2环境兼容）
    // initPdfjs() {
    //   if (window.pdfjsLib) {
    //     this.pdfjsLib = window.pdfjsLib;
    //     if (this.newPdfUrl) this.loadPDF();
    //     return;
    //   }

    //   const workerUrl = '/static/js/pdfjs/pdf.worker.min.js';
    //   const coreUrl = '/static/js/pdfjs/pdf.min.js';

    //   this.loadScript(workerUrl)
    //     .then(() => this.loadScript(coreUrl))
    //     .then(() => {
    //       window.pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;
    //       this.pdfjsLib = window.pdfjsLib;
    //       if (this.newPdfUrl) this.loadPDF();
    //     })
    //     .catch(err => {
    //       console.error('PDFJS加载失败：', err);
    //       this.isLoadError = true;
    //     });
    // },
    loadScript(url, timeout = 10000) {
      return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${url}"]`);
        if (existingScript) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = url;
        const timer = setTimeout(() => {
          reject(new Error(`加载超时：${url}`));
          script.remove();
        }, timeout);
        script.onload = () => {
          clearTimeout(timer);
          resolve();
        };
        script.onerror = () => {
          clearTimeout(timer);
          reject(new Error(`加载失败：${url}`));
        };
        document.head.appendChild(script);
      });
    },
    // 重置PDF状态
    resetPDF() {
      this.isLoading = false;
      this.isLoadError = false;
      this.pdfDoc = null;
      this.pageNum = 1;
      this.resetCanvasWrap();
    },
    // 清空Canvas容器
    resetCanvasWrap() {
      if (this.$refs.pdfCanvasWrap) {
        this.$refs.pdfCanvasWrap.innerHTML = '';
      }
    },
    // 加载PDF文件
    loadPDF() {
      if (!this.pdfjsLib || !this.newPdfUrl) return;
      this.resetPDF();
      this.isLoading = true;
      // Vue2中async/await可直接用，也可改用Promise链式调用，这里保留更简洁的async/await
      (async () => {
        try {
          const pdf = await this.pdfjsLib.getDocument({
            url: this.newPdfUrl,
            // cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.16.105/cmaps/', // 解决中文乱码
            cMapUrl: '/static/cmaps/', // 修改为本地静态资源路径
            cMapPacked: true,
            withCredentials: false
          }).promise;
          this.pdfDoc = pdf;
          this.isLoading = false;
          this.renderAllPages();
        } catch (err) {
          console.error('PDF加载失败：', err);
          this.isLoading = false;
          this.isLoadError = true;
        }
      })();
    },
    // 渲染所有PDF页面
    renderAllPages() {
      if (!this.pdfDoc) return;
      this.resetCanvasWrap();
      this.pageNum = 1;
      this.renderPage(this.pageNum);
    },
    // 核心：渲染单页（DPR高清适配+缩放适配，解决移动端模糊）
    renderPage(num) {
      if (!this.pdfDoc || this.pageRendering) return;
      this.pageRendering = true;
      (async () => {
        try {
          const page = await this.pdfDoc.getPage(num);
          const wrapEl = this.$refs.pdfCanvasWrap;
          if (!wrapEl) return;
          // 基础容器宽度
          const wrapWidth = wrapEl.clientWidth || 300;
          // 基础视口计算
          const baseViewport = page.getViewport({ scale: this.currentScale });
          // 适配容器的缩放比例
          const scaleRatio = wrapWidth / baseViewport.width;
          // 最终缩放：手势缩放 + 容器适配 + 设备像素比（高清核心）
          const finalScale = this.currentScale * scaleRatio * this.dpr;
          const scaledViewport = page.getViewport({ scale: finalScale });

          // 创建Canvas元素
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          // Canvas物理分辨率（乘以DPR，保证高清）
          canvas.width = scaledViewport.width;
          canvas.height = scaledViewport.height;
          // Canvas显示分辨率（除以DPR，避免显示过大）
          canvas.style.width = `${scaledViewport.width / this.dpr}px`;
          canvas.style.height = `${scaledViewport.height / this.dpr}px`;
          canvas.style.margin = '10px auto';
          canvas.style.display = 'block';
          canvas.style.border = '1px solid #eee';

          // 渲染PDF到Canvas
          await page.render({ canvasContext: ctx, viewport: scaledViewport }).promise;
          wrapEl.appendChild(canvas);
          this.pageRendering = false;

          // 渲染下一页
          if (this.pageNumPending) {
            this.renderPage(this.pageNumPending);
            this.pageNumPending = null;
          } else if (num < this.pdfDoc.numPages) {
            this.queueRenderPage(num + 1);
          }
        } catch (err) {
          console.error('PDF渲染失败：', err);
          this.pageRendering = false;
          this.isLoadError = true;
        }
      })();
    },
    // 队列渲染，防止重复渲染
    queueRenderPage(num) {
      this.pageNumPending = num;
      if (!this.pageRendering) this.renderPage(num);
      this.pageNum = num;
    },
    // 计算双指距离
    getTouchDistance(touches) {
      if (touches.length < 2) return 0;
      const x = touches[0].clientX - touches[1].clientX;
      const y = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(x * x + y * y);
    },
    // 触摸开始：初始化双指缩放状态
    handleTouchStart(e) {
      if (e.touches.length === 2) {
        this.touchInfo.isPinching = true;
        this.touchInfo.startDistance = this.getTouchDistance(e.touches);
        this.touchInfo.startScale = this.currentScale;
        e.preventDefault(); // 双指时阻止默认行为
      }
    },
    // 触摸移动：处理双指缩放（核心缩放逻辑）
    handleTouchMove(e) {
      if (!this.touchInfo.isPinching || e.touches.length < 2) return;
      e.preventDefault();
      // 计算新的缩放比例
      const newDistance = this.getTouchDistance(e.touches);
      const scaleRatio = newDistance / this.touchInfo.startDistance;
      // 缩放范围：0.3~4倍，适配移动端使用
      const newScale = Math.max(0.3, Math.min(4, this.touchInfo.startScale * scaleRatio));
      // 低阈值，提升缩放灵敏度
      if (Math.abs(newScale - this.currentScale) > 0.005) {
        this.currentScale = newScale;
        // 防抖渲染，避免卡顿
        clearTimeout(this.renderDebounceTimer);
        this.renderDebounceTimer = setTimeout(() => {
          this.renderAllPages();
        }, 16);
      }
    },
    // 触摸结束：重置缩放状态
    handleTouchEnd() {
      this.touchInfo.isPinching = false;
      this.touchInfo.startDistance = 0;
      this.touchInfo.startScale = 0;
    }
  }
};
</script>

<!-- 改为纯CSS，Vue2老项目无需配置less/sass，直接兼容 -->
<style lang="less" >
.pdf-preview-container {
  width: 100%;
  // min-height:300px; /* 改为全屏，适配移动端 */
  box-sizing: border-box;
}
.pdf-box {
  width: 100%;
  height: 100%;
  // overflow: auto;
  position: relative;
  -webkit-overflow-scrolling: touch; // 开启移动端弹性滚动
  touch-action: pan-y; // 仅允许垂直滚动，缩放由JS处理
}
.pdf-canvas-wrap {
  width: 100%;
  min-height: 100%;
  // touch-action: none; // 禁用浏览器默认触摸行为，完全由JS控制
  >canvas{
    margin: 0px!important;
  }
}
.pdf-loading, .pdf-error-tip, .pdf-placeholder {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #666;
  font-size: 14px;
  text-align: center;
  width: 80%;
}
.pdf-placeholder {
  color: #ccc;
}

// 优化移动端滚动体验
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 2px;
}
</style>